import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback, useEffect } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { CertificateFormVM } from 'front-office/view-models/certificate/certificate-form';
// import AccordionApplicantForm from './form';
import AccordionGeneralityForm from '../generality-historical/form';
import { AccordionApplicantFormVM } from 'front-office/view-models/certificate/applicant-form';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';
import { useAccountHolder } from 'front-office/hooks/storage';

interface ApplicantProps {
  disabled?: boolean;
  hasAccountholder?: boolean;
  isDisabledAccountholder?: boolean;
}

const ApplicantComponent = ({
  disabled,
  hasAccountholder,
  isDisabledAccountholder,
}: ApplicantProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CertificateFormVM>();

  const accountHolderContext = useAccountHolder();

  useEffect(() => {
    formContext.setFieldValue('applicant', accountHolderContext.values?.applicant);
  }, []);

  useEffect(() => {
    accountHolderContext.setValues({
      applicant: formContext.values.applicant,
    });
  }, [formContext.values.applicant]);

  const onFieldApplicantChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('applicant', {
        ...formContext.values.applicant,
        [key]: value,
      });
    },
    [formContext.values.applicant, formContext.setFieldValue]
  );

  const onFieldGeneralityChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('generality', {
        ...formContext.values.generality,
        [key]: value,
      });
    },
    [formContext.values.generality, formContext.setFieldValue]
  );

  const onFieldsGeneralityChange = useCallback(
    (values) => {
      formContext.setFieldValue('generality', {
        ...formContext.values.generality,
        ...(values || {}),
      });
    },
    [formContext.values.generality, formContext.setFieldValue]
  );

  useEffect(() => {
    if (formContext?.values?.certificateInternOnly && !isDisabledAccountholder) {
      setOpen(false);
    }
  }, [formContext?.values?.certificateInternOnly, isDisabledAccountholder]);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-certificate-applicant-content"
        id="panel-certificate-applicant-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Richiedente</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {/* <AccordionApplicantForm
          disabled={disabled}
          values={formContext.values.applicant}
          errors={formContext.errors.applicant as FormikErrors<AccordionApplicantFormVM>}
          touched={formContext.touched.applicant as FormikTouched<AccordionApplicantFormVM>}
          onChange={onFieldApplicantChange}
        /> */}
        <AccordionGeneralityForm
          disabled={disabled}
          values={formContext.values.generality}
          applicant={formContext.values.applicant}
          onChange={onFieldGeneralityChange}
          onChangeValues={onFieldsGeneralityChange}
          allValues={formContext.values}
          hasAccountholder={hasAccountholder}
          visibilityTable={formContext.values.visibilitySearchApplicant || false}
          setVisibilityTable={(visibility) =>
            formContext.setFieldValue('visibilitySearchApplicant', visibility)
          }
          setValues={formContext.setValues}
          errors={formContext.errors.generality as FormikErrors<AccordionGeneralityFormVM>}
          touched={
            formContext.touched.generality as unknown as FormikTouched<AccordionGeneralityFormVM>
          }
          valuesPerson={formContext.values.applicant}
          errorsPerson={formContext.errors.applicant as FormikErrors<AccordionApplicantFormVM>}
          touchedPerson={
            formContext.touched.applicant as unknown as FormikTouched<AccordionApplicantFormVM>
          }
          onChangePerson={onFieldApplicantChange}
        />
      </AccordionDetails>
    </Accordion>
  );
};

ApplicantComponent.displayName = 'Accordion applicant component';

const Applicant = memo(ApplicantComponent);

export default Applicant;
